const sharedFaqs = [
  {
    question: 'Czy ClientWay jest naprawdę darmowy dla usługodawców?',
    answer: 'Tak, system jest darmowy dla usługodawców i nie wymaga karty płatniczej, żeby zacząć.',
  },
  {
    question: 'Czy klienci muszą zakładać konto?',
    answer: 'Nie, zapis odbywa się bez zakładania konta i bez instalowania aplikacji.',
  },
  {
    question: 'Czy mogę używać ClientWay na telefonie i komputerze?',
    answer: 'Tak, panel działa w przeglądarce i wygodnie obsługuje się go na różnych urządzeniach.',
  },
];

function createIndustryPage({
  slug,
  badge,
  heroSubject,
  title,
  description,
  keywords,
  intro,
  featureCards,
  commandCenter,
  trust,
  related,
}) {
  return {
    slug,
    path: `/${slug}`,
    badge,
    h1: `Darmowy kalendarz wizyt dla ${heroSubject || badge}. 0 zł prowizji, 0 zł za SMS.`,
    title,
    description,
    keywords,
    heroLead: 'Zarządzaj biznesem z telefonu i komputera. Nie płacisz za system, nie płacisz za nowych klientów. Cały zysk zostaje u Ciebie.',
    intro,
    featuresTitle: 'Dlaczego ClientWay?',
    featuresSubtitle: 'Najważniejsze cechy, które skracają drogę od chaosu do porządku w kalendarzu.',
    featureCards,
    commandCenterTitle: 'Twoje Centrum Dowodzenia',
    commandCenterSubtitle: 'Nie tylko kalendarz, ale Twój asystent.',
    commandCenter,
    trustTitle: 'Techniczna Uczciwość',
    trustSubtitle: 'Dlaczego nam ufać?',
    trust,
    ctaTitle: 'Zacznij używać za darmo – bez karty i zobowiązań',
    ctaSubtitle: 'Dołącz do setek profesjonalistów, którzy przestali płacić prowizje od swoich klientów.',
    ctaButtonLabel: 'Zacznij używać za darmo – bez karty i zobowiązań',
    ctaNote: 'Bez karty, bez abonamentu i bez opłat za SMS.',
    faqs: sharedFaqs,
    related,
  };
}

const commonFeatureCards = [
  {
    icon: 'sparkles',
    title: 'Błyskawiczny Start',
    text: 'Konfiguracja w 3 minuty. Gotowe szablony usług i grafiku pomagają ruszyć bez długiego wdrożenia.',
  },
  {
    icon: 'check',
    title: 'Rezerwacje bez barier',
    text: 'Klienci nie muszą zakładać konta ani instalować aplikacji. Podają imię, telefon i gotowe.',
  },
  {
    icon: 'dashboard',
    title: 'Multi-urządzeniowość',
    text: 'Pełna kontrola w przeglądarce na komputerze i szybka aplikacja SPA na telefonie.',
  },
  {
    icon: 'clock',
    title: 'Inteligentny Grafik',
    text: 'System pilnuje przerw, blokad i nie pozwala na zdublowane wizyty.',
  },
];

const commonCommandCenter = [
  'Automatyczna baza klientów z historią wizyt.',
  'Statystyki dziennej wartości usług i obłożenia.',
  'Podgląd wolnych okien na pierwszy rzut oka.',
];

const commonTrust = [
  'W kodzie nie ma modułów płatniczych ani subskrypcji, więc nie ma ukrytego abonamentu.',
  'Hasła są hashowane, a dostęp do panelu opiera się na tokenach i kontroli ról.',
  'System jest lekki i działa płynnie nawet przy słabszym internecie w salonie.',
];

export const industryPages = {
  fryzjer: createIndustryPage({
    slug: 'fryzjer',
    badge: 'Fryzjer',
    heroSubject: 'fryzjera',
    title: 'Darmowy kalendarz dla fryzjera - ClientWay',
    description: 'Darmowy kalendarz wizyt dla fryzjera z rezerwacjami 24/7, przypomnieniami SMS i bazą klientów. 0 zł prowizji, 0 zł za SMS.',
    keywords: 'darmowy kalendarz dla fryzjera, rezerwacje online fryzjer, 0 zł prowizji, 0 zł za sms, przypomnienia sms',
    intro: 'Prowadzenie salonu fryzjerskiego wymaga spokoju i skupienia. ClientWay odciąża Cię od telefonu, skraca drogę do rezerwacji i porządkuje cały grafik.',
    featureCards: commonFeatureCards,
    commandCenter: commonCommandCenter,
    trust: commonTrust,
    related: ['kosmetyczka', 'barber', 'fizjoterapeuta', 'trener-personalny'],
  }),
  kosmetyczka: createIndustryPage({
    slug: 'kosmetyczka',
    badge: 'Kosmetyczka',
    heroSubject: 'kosmetyczki',
    title: 'Darmowy kalendarz dla kosmetyczki - ClientWay',
    description: 'Darmowy system rezerwacji dla kosmetyczki z kalendarzem online 24/7, przypomnieniami SMS i bazą klientek. 0 zł prowizji, 0 zł za SMS.',
    keywords: 'darmowy kalendarz dla kosmetyczki, system rezerwacji kosmetyczka, 0 zł prowizji, 0 zł za sms, baza klientek',
    intro: 'Salon kosmetyczny potrzebuje porządku, szybkości i prostych zapisów. ClientWay daje Ci darmowy kalendarz, który działa bez zbędnych formalności.',
    featureCards: commonFeatureCards,
    commandCenter: commonCommandCenter,
    trust: commonTrust,
    related: ['fryzjer', 'barber', 'fizjoterapeuta', 'trener-personalny'],
  }),
  barber: createIndustryPage({
    slug: 'barber',
    badge: 'Barber',
    heroSubject: 'barbera',
    title: 'Darmowy kalendarz dla barbera - ClientWay',
    description: 'Darmowy system rezerwacji dla barbera z kalendarzem 24/7, przypomnieniami SMS i historią klientów. 0 zł prowizji, 0 zł za SMS.',
    keywords: 'darmowy kalendarz barber, system rezerwacji barber, 0 zł prowizji, 0 zł za sms, historia klientów',
    intro: 'Barbershop wygrywa szybkością i wygodą. ClientWay pozwala klientom zapisać się od razu, a Tobie trzymać pełną kontrolę nad fotelami i przerwami.',
    featureCards: commonFeatureCards,
    commandCenter: commonCommandCenter,
    trust: commonTrust,
    related: ['fryzjer', 'kosmetyczka', 'fizjoterapeuta', 'trener-personalny'],
  }),
  fizjoterapeuta: createIndustryPage({
    slug: 'fizjoterapeuta',
    badge: 'Fizjoterapeuta',
    heroSubject: 'fizjoterapeuty',
    title: 'Darmowy kalendarz dla fizjoterapeuty - ClientWay',
    description: 'Darmowy program dla fizjoterapeutów z kalendarzem wizyt, bazą pacjentów i przypomnieniami SMS. 0 zł prowizji, 0 zł za SMS.',
    keywords: 'darmowy kalendarz fizjoterapeuta, program dla fizjoterapeuty, 0 zł prowizji, 0 zł za sms, baza pacjentów',
    intro: 'W gabinecie fizjoterapii liczy się porządek i ciągłość terapii. ClientWay porządkuje wizyty, ułatwia planowanie i pozwala skupić się na pacjencie.',
    featureCards: commonFeatureCards,
    commandCenter: commonCommandCenter,
    trust: commonTrust,
    related: ['fryzjer', 'kosmetyczka', 'barber', 'trener-personalny'],
  }),
  'trener-personalny': createIndustryPage({
    slug: 'trener-personalny',
    badge: 'Trener personalny',
    heroSubject: 'trenera personalnego',
    title: 'Darmowy kalendarz dla trenera personalnego - ClientWay',
    description: 'Darmowy system rezerwacji treningów dla trenerów personalnych z kalendarzem, przypomnieniami SMS i historią klientów. 0 zł prowizji, 0 zł za SMS.',
    keywords: 'darmowy kalendarz trener personalny, system rezerwacji treningów, 0 zł prowizji, 0 zł za sms, historia klientów',
    intro: 'Klient nie powinien pisać wielu wiadomości, żeby zarezerwować sesję. ClientWay skraca zapis do kilku kliknięć i trzyma porządek w grafiku.',
    featureCards: commonFeatureCards,
    commandCenter: commonCommandCenter,
    trust: commonTrust,
    related: ['fryzjer', 'kosmetyczka', 'barber', 'fizjoterapeuta'],
  }),
};

export const industryPageOrder = [
  industryPages.fryzjer,
  industryPages.kosmetyczka,
  industryPages.barber,
  industryPages.fizjoterapeuta,
  industryPages['trener-personalny'],
];

export function getIndustryPageBySlug(slug) {
  return industryPages[slug] || null;
}
